<!--- question-card horizontal-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="fx-column fx-start-stretch">
		<div class="question-card fx-row fx-space-between-stretch">

			<div class="fx-row fx-start-center fx-grow fx-shrink">

				<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
					<div class="thumbnail-block fx-row">
						<div class="thumbnail fx-row fx-center-center">
							<ng-container *ngIf="![null, undefined, ''].includes(cardData?.thumbnail)">
								<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'man')">
							</ng-container>
							<ng-container *ngIf="[null, undefined, ''].includes(cardData?.thumbnail)">
								<img src="assets/img/man.png">
							</ng-container>
							<!-- <ng-container *ngIf="cardData?.thumbnail">
									<img [src]="cardData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</ng-container> -->
						</div>
					</div>
				</div>
				<ng-container *ngIf="data?.title">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<!-- <div class="patch-block fx-row fx-space-between-center">
							<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
							</ng-container>
						</div> -->
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<div class="title-blk fx-column fx-grow fx-shrink">
								<ng-container *ngIf="data?.title" [ngTemplateOutlet]="title"
									[ngTemplateOutletContext]="data">
								</ng-container>
							</div>
							<!-- <div class="fx-row-wrap fx-space-between-center">
								<ng-container *ngIf="data?.date || data?.title">
									<div class="fx-row fx-start-center">
										<div class="contributor fx-row fx-start-center">
											<span>{{locale.translate('mcq')}}</span>
										</div>
										<ng-container *ngIf="data?.date">
											<div class="date fx-row fx-start-center" fxLayoutGap="5px">
												<span>{{data?.date}}</span>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</div> -->
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="data?.removable" class="cancel" fxLayoutAlign="start start">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': data})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>



<ng-template #title>
	<div fxLayoutAlign="start center">
		<p class="card-title linkable" (click)="info(data)" [innerHtml]="data?.title | safeDom"></p>
	</div>
</ng-template>
<!--
<ng-template #typePatch>
	<div class="content-type" fxLayoutAlign="start start">
		<div class="patch sub-txt-patch">{{ locale.translate('question') }}</div>
	</div>
</ng-template>

<ng-template #statusPatch>
	<p class="sub-txt-patch warn">{{ locale.translate('public') }}</p>
</ng-template> -->